export function linkifyText(text) {
  if ('string' === typeof text) {
    let linkifiedText = text
    const REGEX_URL = /(https?:\/\/|www\.)[^\s'<]+/gi

    linkifiedText = linkifiedText.replace(REGEX_URL, match => {
      try {
        const uri = ('www' === match.slice(0, 3).toLowerCase() ? 'https://' : '') + match
        const [link, shortName, other] = uri.split(/[()]/)
        const name = shortName ? shortName.replace(/_/g, ' ') : null
        return `<a href='${link}' target='_blank' rel='noopener'>${
          name || decodeURIComponent(new URL(link).hostname)
        }</a>${other || ''}`
      } catch {
        return match
      }
    })
    return linkifiedText
  }
  return text
}
